// Section labels are now a shared sidebar primitive so every filter sidebar
// renders them identically. Kept as a thin wrapper for the existing call sites.
import { SidebarSectionLabel } from 'components/layout/SidebarLayout/SidebarSectionLabel';

type FilterSectionLabelProps = {
  label: string;
  isFirst?: boolean;
};

const FilterSectionLabel = (props: FilterSectionLabelProps) => (
  <SidebarSectionLabel {...props} />
);

export default FilterSectionLabel;
